module.exports = __webpack_public_path__ + "img/plant_3_mobile.e99f6c71.webp";